import { render, staticRenderFns } from "./CragRouteAvatar.vue?vue&type=template&id=23c78521"
import script from "./CragRouteAvatar.vue?vue&type=script&lang=js"
export * from "./CragRouteAvatar.vue?vue&type=script&lang=js"
import style0 from "./CragRouteAvatar.vue?vue&type=style&index=0&id=23c78521&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports